/**
 * @architecture-header 1
 * @layer module-ui
 * @domain settings-subscription
 * @responsibility Compose independently tuned desktop and mobile SET-F08 Subscription pane
 *   surfaces: the static plan matrix, the current-plan badge, and a contact-to-upgrade link.
 * @state-owner none -- fully static, no props beyond the surface toggle
 * @allowed-imports React; shared translator; same-module static plan-matrix data
 * @forbidden direct API client; any button, form, dialog, or payment-shaped input; a seat-usage counter
 * @public-api SubscriptionSettingsSurface
 * @side-effects none
 * @tests SubscriptionSettingsSurface.test.tsx
 */

import { useTranslator } from '../../../shared/model/use-workspace';
import './settings-subscription.css';
import { SUBSCRIPTION_PLANS } from './plan-matrix';

export interface SubscriptionSettingsSurfaceProps {
  mobile: boolean;
}

export function SubscriptionSettingsSurface(props: SubscriptionSettingsSurfaceProps) {
  const t = useTranslator();
  return (
    <section
      aria-label={t('Subscription')}
      className={`subscription-settings-pane${props.mobile ? ' subscription-settings-pane--mobile' : ' subscription-settings-pane--desktop'}`}
    >
      <div className="subscription-settings-pane__section">
        <span className="subscription-settings-pane__label">{t('目前方案：Free')}</span>
      </div>

      <ul className="subscription-settings-pane__plans">
        {SUBSCRIPTION_PLANS.map((plan) => (
          <li
            className={`subscription-settings-pane__plan${plan.current ? ' subscription-settings-pane__plan--current' : ''}`}
            key={plan.id}
          >
            <strong>{t(plan.name)}</strong>
            <span className="subscription-settings-pane__price">{t(plan.price)}</span>
            <ul className="subscription-settings-pane__features">
              {plan.features.map((feature) => (
                <li key={feature}>{t(feature)}</li>
              ))}
            </ul>
            {plan.current ? (
              <span className="subscription-settings-pane__badge">{t('目前方案')}</span>
            ) : null}
            {plan.comingSoon ? (
              <span className="subscription-settings-pane__badge subscription-settings-pane__badge--soon">
                {t('即將推出')}
              </span>
            ) : null}
          </li>
        ))}
      </ul>

      <div className="subscription-settings-pane__section">
        <span className="subscription-settings-pane__label">{t('升級方案')}</span>
        <p>{t('如需升級方案，請與我們聯絡。')}</p>
        <a href="mailto:support@vispo.app">{t('聯絡我們')}</a>
      </div>
    </section>
  );
}
